import { Button, Card, Empty, Tooltip, Typography } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import AddClosedPeriod from "../../Modal/AddClosedPeriod";
import { useEffect, useState } from "react";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { changeLoader } from "../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import {
  formatDateFunction,
  formatDateFunctionNew,
} from "../../utils/helper/utils";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { checkPermissionAction } from "../../utils/helper/utils";

const Holidays = () => {
  const dispatch = useDispatch();
  let { id } = useParams();

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const [item, setItem] = useState(null);
  const [items, setItems] = useState([]);

  const [addHolidayModalOpen, setAddHolidayModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const showAddHolidayModal = () => {
    setAddHolidayModalOpen(true);
  };
  const handleAddHolidaysOk = () => {
    setAddHolidayModalOpen(false);
  };
  const handleAddHolidaysCancel = () => {
    setAddHolidayModalOpen(false);
  };

  const handleDeleteOk = async () => {
    let updateData = { status: "deleted" };
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_ZONE?.UPDATE_HOLIDAY_STATUS + "/" + item.id;
      let method = "put";
      let response = await globalRequest(url, method, updateData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Holiday deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllHolidays(id);
        setIsDeleteModalOpen(false);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const getAllHolidays = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_ZONE.GET_ALL_HOLIDAYS + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data?.data?.data;
      setItems(apiResponse);
    } catch (e) {
      toast.error(e?.message);
    }
  };
  useEffect(() => {
    getAllHolidays(id);
  }, [id]);

  const addEditHoliday = async (form) => {
    let sd = formatDateFunction(new Date(form?.start_date), "yyyy-mm-dd");
    let ed = formatDateFunction(new Date(form?.end_date), "yyyy-mm-dd");

    let insertData = {
      type: "zone",
      id: id,
      start_date: sd,
      end_date: ed,
      description: form?.description,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_ZONE?.CREATE_HOLIDAY;
      let method = "post";
      if (form.id > 0) {
        url = Apis?.MANAGE_ZONE?.EDIT_HOLIDAY + "/" + form.id;
        method = "put";
      }
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Holiday created successfully";
        if (form.id) msg = "Holiday updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllHolidays(id);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <div className="flex justify-between items-center mb-5 gap-5 min-w-[600px]">
        <div className="">
          <Typography
            className="text-xl font-semibold whitespace-nowrap"
            align={"left"}
          >
            Closed Periods
          </Typography>
          <p className="text-base whitespace-nowrap">
            Set the period when your business is closed.
          </p>
        </div>
        <div>
          {checkPermissionAction(
            "Zone specific Timeslots & Holidays",
            permissionJson,
            "add"
          ) ? (
            <Button
              type="primary"
              size={14}
              icon={<PlusOutlined />}
              className="mx-1.5 cursor-pointer"
              onClick={() => {
                showAddHolidayModal();
                setItem(null);
              }}
            >
              Add Closed Period
            </Button>
          ) : null}
        </div>
      </div>
      <div className="flex flex-col gap-4 max-h-[450px] min-w-[600px] overflow-auto custom-scrollbar">
        {items?.length ? (
          items?.map((itm, index) => (
            <Card key={index}>
              <div className="flex justify-between items-center">
                <div className="font-semibold text-base">
                  {formatDateFunctionNew(itm.startDate)} -{" "}
                  {formatDateFunctionNew(itm.endDate)}
                </div>
                <div>
                  {checkPermissionAction(
                    "Zone specific Timeslots & Holidays",
                    permissionJson,
                    "edit"
                  ) ? (
                    <Tooltip title="Edit">
                      <EditOutlined
                        className="mx-1.5 cursor-pointer"
                        onClick={() => {
                          showAddHolidayModal();
                          setItem(itm);
                        }}
                      />
                    </Tooltip>
                  ) : null}
                  {checkPermissionAction(
                    "Zone specific Timeslots & Holidays",
                    permissionJson,
                    "delete"
                  ) ? (
                    <Tooltip title="Delete">
                      <DeleteOutlined
                        className="mx-1.5 cursor-pointer"
                        onClick={() => {
                          setIsDeleteModalOpen(true);
                          setItem(itm);
                        }}
                      />
                    </Tooltip>
                  ) : null}
                </div>
              </div>
            </Card>
          ))
        ) : (
          <div className="flex flex-col justify-center items-center">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
      </div>

      {addHolidayModalOpen && (
        <AddClosedPeriod
          isOpen={addHolidayModalOpen}
          onOk={handleAddHolidaysOk}
          onCancel={handleAddHolidaysCancel}
          data={item || null}
          onSubmit={(data) => {
            //function add/edit
            addEditHoliday(data);
          }}
        />
      )}
      {/* delete modal */}
      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this Holiday?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </>
  );
};
export default Holidays;
